import React, { useState } from 'react';
import './login.scss';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Environment from '../../utils/Enviroment';
import Loader from '../../utils/loader';

const Login = () => {

  const [show, setShow] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Validation for email
  const validateEmail = (email) => {
    if (!email) {
      setError('Email is required.');
      return false;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address.');
      return false;
    }
    return true;
  };

  // Validation for password
  const validatePassword = (password) => {
    if (!password) {
      setError('Password is required.');
      return false;
    }
    return true;
  };

  const handleSignIn = async () => {
    setError(''); // Clear previous errors

    // Run validations separately
    if (!validateEmail(email) || !validatePassword(password)) {
      return;
    }

    try {
      setLoading(true); // Show loading state
      const response = await axios.post(`${Environment?.API_URL}auth/admins/signin`, { email, password });
      console.log(response, "response in login api");

      if (response) {
        localStorage.setItem('adminAccessToken', response?.data?.data?.accessToken);
        console.log('Login successful:', response.data)
        navigate('/admin'); // Navigate to admin dashboard
      } else {
        setError('Invalid credentials. Please try again.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(err?.response?.data?.message ? err?.response?.data?.message : 'Something went wrong. Please try again later.');
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <>
      {loading && <Loader />}
      <section className="Login_section">
        <img src="/assets/StableNFTbg.svg" className="imgbglogin img-fluid" alt="Background" />
        <div className="Head_main">
          <div className="Main_login">
            <img src="/assets/nftlogo.svg" alt="Logo" />
            <h1>Log into your admin account</h1>
            <p>Please enter your details to access your admin account</p>

            <h2>Email Address</h2>
            <input
              type="text"
              placeholder="Enter your Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <div className='main_new_div'>
              {
                show ?
                  <svg onClick={() => setShow(!show)} className='svgeye' xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M19.3211 10.2085C19.2937 10.1468 18.632 8.67886 17.1609 7.20776C15.2008 5.24761 12.725 4.21167 9.99999 4.21167C7.27499 4.21167 4.79921 5.24761 2.83905 7.20776C1.36796 8.67886 0.703118 10.1492 0.678899 10.2085C0.643362 10.2885 0.625 10.375 0.625 10.4625C0.625 10.5499 0.643362 10.6364 0.678899 10.7164C0.706243 10.7781 1.36796 12.2453 2.83905 13.7164C4.79921 15.6757 7.27499 16.7117 9.99999 16.7117C12.725 16.7117 15.2008 15.6757 17.1609 13.7164C18.632 12.2453 19.2937 10.7781 19.3211 10.7164C19.3566 10.6364 19.375 10.5499 19.375 10.4625C19.375 10.375 19.3566 10.2885 19.3211 10.2085ZM9.99999 15.4617C7.5953 15.4617 5.49452 14.5875 3.75546 12.864C3.0419 12.1544 2.43483 11.3452 1.95312 10.4617C2.4347 9.57803 3.04179 8.76884 3.75546 8.05933C5.49452 6.33589 7.5953 5.46167 9.99999 5.46167C12.4047 5.46167 14.5055 6.33589 16.2445 8.05933C16.9595 8.76867 17.5679 9.57786 18.0508 10.4617C17.4875 11.5132 15.0336 15.4617 9.99999 15.4617ZM9.99999 6.71167C9.25831 6.71167 8.53329 6.9316 7.9166 7.34366C7.29992 7.75571 6.81927 8.34138 6.53544 9.02661C6.25162 9.71183 6.17735 10.4658 6.32205 11.1933C6.46674 11.9207 6.82389 12.5889 7.34834 13.1133C7.87279 13.6378 8.54097 13.9949 9.2684 14.1396C9.99583 14.2843 10.7498 14.21 11.4351 13.9262C12.1203 13.6424 12.7059 13.1617 13.118 12.5451C13.5301 11.9284 13.75 11.2034 13.75 10.4617C13.749 9.46743 13.3535 8.5142 12.6505 7.81116C11.9475 7.10812 10.9942 6.7127 9.99999 6.71167ZM9.99999 12.9617C9.50554 12.9617 9.02219 12.815 8.61107 12.5403C8.19994 12.2656 7.87951 11.8752 7.69029 11.4184C7.50107 10.9616 7.45157 10.4589 7.54803 9.97394C7.64449 9.48899 7.88259 9.04353 8.23222 8.6939C8.58186 8.34427 9.02731 8.10617 9.51227 8.00971C9.99722 7.91324 10.4999 7.96275 10.9567 8.15197C11.4135 8.34119 11.804 8.66162 12.0787 9.07274C12.3534 9.48387 12.5 9.96722 12.5 10.4617C12.5 11.1247 12.2366 11.7606 11.7678 12.2294C11.2989 12.6983 10.663 12.9617 9.99999 12.9617Z" fill="black" />
                  </svg>
                  :
                  <svg onClick={() => setShow(!show)} className='svgeye1' xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M4.21249 2.70468C4.15761 2.64281 4.09099 2.59245 4.01649 2.55652C3.942 2.52058 3.86111 2.49979 3.77853 2.49535C3.69594 2.49091 3.61329 2.5029 3.53537 2.53063C3.45746 2.55837 3.38582 2.60129 3.32461 2.65691C3.2634 2.71254 3.21384 2.77976 3.17881 2.85467C3.14377 2.92959 3.12395 3.01072 3.1205 3.09336C3.11704 3.17599 3.13003 3.25849 3.15869 3.33607C3.18736 3.41365 3.23114 3.48477 3.28749 3.5453L4.79062 5.19921C1.95312 6.94062 0.732805 9.62499 0.678899 9.74687C0.643362 9.8268 0.625 9.9133 0.625 10.0008C0.625 10.0882 0.643362 10.1747 0.678899 10.2547C0.706243 10.3164 1.36796 11.7836 2.83905 13.2547C4.79921 15.2141 7.27499 16.25 9.99999 16.25C11.4005 16.258 12.7868 15.9696 14.068 15.4039L15.7867 17.2953C15.8416 17.3572 15.9082 17.4075 15.9827 17.4435C16.0572 17.4794 16.1381 17.5002 16.2207 17.5046C16.3033 17.5091 16.3859 17.4971 16.4638 17.4694C16.5417 17.4416 16.6134 17.3987 16.6746 17.3431C16.7358 17.2874 16.7854 17.2202 16.8204 17.1453C16.8554 17.0704 16.8753 16.9893 16.8787 16.9066C16.8822 16.824 16.8692 16.7415 16.8405 16.6639C16.8118 16.5863 16.7681 16.5152 16.7117 16.4547L4.21249 2.70468ZM7.91015 8.62968L11.1656 12.2117C10.6754 12.4696 10.1134 12.5574 9.56783 12.4613C9.02229 12.3651 8.52413 12.0906 8.15157 11.6806C7.77901 11.2707 7.55314 10.7486 7.50945 10.1964C7.46575 9.6442 7.6067 9.09311 7.91015 8.62968ZM9.99999 15C7.5953 15 5.49452 14.1258 3.75546 12.4023C3.04164 11.6929 2.43454 10.8837 1.95312 9.99999C2.31952 9.31327 3.48905 7.3914 5.65234 6.14218L7.05859 7.68515C6.51416 8.38242 6.23377 9.24971 6.26697 10.1337C6.30017 11.0177 6.64483 11.8615 7.24002 12.516C7.83521 13.1705 8.64261 13.5935 9.51952 13.7102C10.3964 13.8269 11.2864 13.6299 12.032 13.1539L13.1828 14.4195C12.1672 14.8092 11.0878 15.006 9.99999 15ZM10.4687 7.54452C10.3059 7.51344 10.162 7.41894 10.0689 7.2818C9.97568 7.14467 9.94079 6.97613 9.97187 6.81327C10.0029 6.65041 10.0975 6.50657 10.2346 6.41339C10.3717 6.32021 10.5403 6.28532 10.7031 6.3164C11.4997 6.47083 12.225 6.87862 12.7708 7.47897C13.3167 8.07931 13.6539 8.84002 13.732 9.64765C13.7475 9.81268 13.6967 9.97709 13.5909 10.1047C13.4851 10.2323 13.333 10.3127 13.168 10.3281C13.1484 10.3293 13.1289 10.3293 13.1094 10.3281C12.9532 10.3288 12.8024 10.2709 12.6867 10.166C12.571 10.061 12.4988 9.91647 12.4844 9.76093C12.4318 9.22374 12.2072 8.71787 11.844 8.31854C11.4809 7.91921 10.9985 7.64775 10.4687 7.54452ZM19.3187 10.2547C19.2859 10.3281 18.4945 12.0805 16.7125 13.6766C16.6516 13.7328 16.5801 13.7764 16.5022 13.8048C16.4243 13.8332 16.3415 13.8458 16.2587 13.8419C16.1759 13.8379 16.0947 13.8176 16.0198 13.782C15.9449 13.7463 15.8779 13.6962 15.8226 13.6344C15.7673 13.5726 15.7249 13.5005 15.6977 13.4221C15.6706 13.3438 15.6593 13.2608 15.6645 13.1781C15.6698 13.0953 15.6914 13.0144 15.7282 12.9401C15.765 12.8658 15.8162 12.7996 15.8789 12.7453C16.7532 11.9599 17.4876 11.0315 18.0508 9.99999C17.5683 9.11544 16.9599 8.30568 16.2445 7.59609C14.5055 5.87421 12.4047 4.99999 9.99999 4.99999C9.49332 4.99937 8.98745 5.0404 8.48749 5.12265C8.40619 5.13703 8.32284 5.13515 8.24227 5.11714C8.1617 5.09912 8.08549 5.06532 8.01805 5.01768C7.95062 4.97005 7.89329 4.90952 7.84938 4.8396C7.80547 4.76968 7.77584 4.69176 7.76222 4.61033C7.7486 4.52889 7.75124 4.44557 7.77 4.36517C7.78877 4.28476 7.82327 4.20887 7.87153 4.14188C7.91979 4.07489 7.98085 4.01813 8.05117 3.97486C8.12149 3.9316 8.19969 3.9027 8.28124 3.88984C8.84934 3.79603 9.4242 3.74926 9.99999 3.74999C12.725 3.74999 15.2008 4.78593 17.1609 6.74609C18.632 8.21718 19.2937 9.68515 19.3211 9.74687C19.3566 9.8268 19.375 9.9133 19.375 10.0008C19.375 10.0882 19.3566 10.1747 19.3211 10.2547H19.3187Z" fill="black" />
                  </svg>
              }
              <h2>Password</h2>
              <input
                type={show ? "text" : "password"}
                placeholder="Enter your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

            </div>

            {/* Display error message */}
            {error && <p className="error-message">{error}</p>}

            {/* Sign In Button */}
            <button onClick={handleSignIn} disabled={loading}>
              {loading ? 'Signing In...' : 'Sign In'}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;